import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import axios from "axios";
import * as moment from "moment";
import {connect}  from  "react-redux";

var yesterday = new Date(Date.now() - 24*60*60*1000);
class SettlementReport extends Component{
    constructor(props) {
        super(props);
        this.state = {
            reportPermissionsArray:[],
            daily_settl_time :'',
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        let subMenuPermissions = [];
        let reportPermissions = [];
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("settlement_reports")===false){
            this.unauthorize_access();
        }
        this.setState({
            reportPermissionsArray:reportPermissions,
            user_id:decoded._id
        });
        this.get_daily_settle_sync();
    }
    get_daily_settle_sync(){
        axios.get(config.get('API_URL')+'/reports/daily-sales-sync/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            this.setState({
                daily_settl_time: response.data.data
            })
        });
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    render() {
        return(
          
                  <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                                <div className="header">
                                                    <h4 className="title">Settlement</h4>
                                                    <p className="category"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="content">
                                    <div className="row">
                                        {this.state.reportPermissionsArray.includes("daily_settlement")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className=""   to="/admin/daily-settlement-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Daily Settlement Report</h5>
                                                            <p className="text-muted">Last updated : {this.state.daily_settl_time!=''?moment(yesterday).format('D MMM YYYY HH:mm:ss'):null}</p>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>: null }
                                        {this.state.reportPermissionsArray.includes("dcc_settlement")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className=""   to="/admin/dcc-settlement-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>DCC Daily Settlement Report</h5>
                                                            <p className="text-muted">Last updated : {moment(yesterday).format('D MMM YYYY HH:mm:ss')}</p>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>: null }
                                        {this.state.reportPermissionsArray.includes("google_pay_settlement")===true?
                                        <div className="col-lg-3 col-xs-6">
                                            <div className="card report-dash">
                                                <div className="content text-center">
                                                    <Link className=""   to="/admin/google-pay-settlement-report/">
                                                        <div className="report-thumbs-ico">
                                                            <div className="icon-big text-center folder-icon">
                                                                <i className="fa fa-folder-o"></i>
                                                            </div>
                                                            <h5>Google Pay Settlement Report</h5>
                                                            <p className="text-muted">Last updated : {moment(yesterday).format('D MMM YYYY HH:mm:ss')}</p>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>: null }

                                        {this.state.reportPermissionsArray.includes("fund_transfer_settlement")===true?
                                            <div className="col-lg-3 col-xs-6">
                                                <div className="card report-dash">
                                                    <div className="content text-center">
                                                        <Link className=""   to="/admin/aggregated-settlement-report/">
                                                            <div className="report-thumbs-ico">
                                                                <div className="icon-big text-center folder-icon">
                                                                    <i className="fa fa-folder-o"></i>
                                                                </div>
                                                                <h5>Aggregated Settlement Report</h5>

                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>: null }

                                    </div>
                                    <div className="row">


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(SettlementReport);